var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserFriendly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9867 12.9467C27.5333 12.7601 26.9333 12.6667 26.1867 12.6667H19.1467C16.8267 12.6667 16 13.4934 16 15.8401V26.1601C16 26.9334 16.0933 27.5334 16.2933 28.0001C16.7067 28.9601 17.5867 29.3334 19.1467 29.3334H26.1867C28.5067 29.3334 29.3333 28.4934 29.3333 26.1601V15.8401C29.3333 14.2534 28.96 13.3601 27.9867 12.9467ZM24 26.3334H21.3333C21.3067 26.3334 21.2667 26.3334 21.24 26.3201C21.04 26.3067 20.8667 26.2401 20.72 26.1067C20.48 25.9334 20.3333 25.6534 20.3333 25.3334C20.3333 24.7867 20.7867 24.3334 21.3333 24.3334H24C24.5467 24.3334 25 24.7867 25 25.3334C25 25.8801 24.5467 26.3334 24 26.3334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9867 8.25341V9.33341C27.9867 10.0667 27.3867 10.6667 26.6534 10.6667H19.1467C15.7334 10.6667 14.0001 12.4134 14.0001 15.8401V28.0001C14.0001 28.7334 13.4001 29.3334 12.6667 29.3334H10.0667C9.53339 29.3334 9.10672 28.9067 9.10672 28.3867C9.10672 27.8534 9.53339 27.4401 10.0667 27.4401H12.6667V22.3334H8.00005C5.04005 22.1867 2.68005 19.7467 2.68005 16.7467V8.25341C2.68005 5.17341 5.18672 2.66675 8.28005 2.66675H22.4001C25.4801 2.66675 27.9867 5.17341 27.9867 8.25341Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFriendly);
export default __webpack_public_path__ + "static/media/user-friendly.3dc8d0bfd9c516f5c4b6d293296d2853.svg";
export { ForwardRef as ReactComponent };